/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);

// Fixed Minimum Order Enforcement - CART DRAWER VERSION (No Popup, Modal Instead)
document.addEventListener('DOMContentLoaded', function() {
  const MINIMUM_QUANTITY = 10;
  
  // Create modal HTML and styles
  function createModal() {
    if (document.getElementById('minimum-order-modal')) return;
    
    const modalHTML = `
      <div id="minimum-order-modal" class="minimum-order-modal" style="
        display: none;
        position: fixed;
        z-index: 10000;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.5);
        backdrop-filter: blur(3px);
      ">
        <div class="modal-content" style="
          background-color: #fff;
          margin: 10% auto;
          padding: 30px;
          border-radius: 12px;
          width: 90%;
          max-width: 500px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.3);
          text-align: center;
          position: relative;
          animation: modalSlideIn 0.3s ease-out;
        ">
          <div style="
            width: 60px;
            height: 60px;
            background: linear-gradient(135deg, #ff6b6b, #ff8e53);
            border-radius: 50%;
            margin: 0 auto 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 24px;
          ">⚠️</div>
          
          <h2 style="
            color: #333;
            margin: 0 0 15px 0;
            font-size: 24px;
            font-weight: 600;
          ">Minimum Order Required</h2>
          
          <p id="modal-message" style="
            color: #666;
            font-size: 16px;
            line-height: 1.5;
            margin: 0 0 25px 0;
          "></p>
          
          <div style="display: flex; gap: 10px; justify-content: center;">
            <button id="modal-continue-shopping" style="
              background: linear-gradient(135deg, #667eea, #764ba2);
              color: white;
              border: none;
              padding: 12px 24px;
              border-radius: 8px;
              cursor: pointer;
              font-size: 14px;
              font-weight: 500;
              transition: transform 0.2s;
            " onmouseover="this.style.transform='translateY(-2px)'" onmouseout="this.style.transform='translateY(0)'">
              Continue Shopping
            </button>
            
            <button id="modal-close" style="
              background: #f8f9fa;
              color: #666;
              border: 1px solid #dee2e6;
              padding: 12px 24px;
              border-radius: 8px;
              cursor: pointer;
              font-size: 14px;
              font-weight: 500;
              transition: transform 0.2s;
            " onmouseover="this.style.transform='translateY(-2px)'" onmouseout="this.style.transform='translateY(0)'">
              Close
            </button>
          </div>
        </div>
      </div>
      
      <style>
        @keyframes modalSlideIn {
          from { transform: translateY(-50px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
      </style>
    `;
    
    document.body.insertAdjacentHTML('beforeend', modalHTML);
    
    // Add event listeners to modal buttons
    document.getElementById('modal-close').addEventListener('click', hideModal);
    document.getElementById('modal-continue-shopping').addEventListener('click', function() {
      hideModal();
      // Close drawer if it's open
      const drawer = document.querySelector('.cart-drawer, .drawer, [data-cart-drawer]');
      if (drawer) {
        drawer.classList.remove('open', 'active');
        drawer.style.display = 'none';
        // Remove any overlay
        const overlay = document.querySelector('.drawer-overlay, .cart-overlay, .overlay');
        if (overlay) overlay.remove();
      }
    });
    
    // Close modal when clicking outside
    document.getElementById('minimum-order-modal').addEventListener('click', function(e) {
      if (e.target === this) hideModal();
    });
  }
  
  function showModal(currentQuantity) {
    createModal();
    const modal = document.getElementById('minimum-order-modal');
    const message = document.getElementById('modal-message');
    
    const needed = MINIMUM_QUANTITY - currentQuantity;
    message.innerHTML = `
      You need <strong>${MINIMUM_QUANTITY} items</strong> to place an order.<br>
      You currently have <strong>${currentQuantity} items</strong>.<br><br>
      Please add <strong>${needed} more item${needed > 1 ? 's' : ''}</strong> to continue.
    `;
    
    modal.style.display = 'block';
    document.body.style.overflow = 'hidden'; // Prevent background scrolling
  }
  
  function hideModal() {
    const modal = document.getElementById('minimum-order-modal');
    if (modal) {
      modal.style.display = 'none';
      document.body.style.overflow = ''; // Restore scrolling
    }
  }
  
  function getCartQuantity() {
    // Method 1: Cart drawer specific - look for drawer quantity displays
    const drawerQuantityElements = document.querySelectorAll('.cart-drawer .cart-count, .drawer .cart-count, [data-cart-drawer] .cart-count, .cart-drawer-count');
    for (let element of drawerQuantityElements) {
      const count = parseInt(element.textContent || '0');
      if (count > 0) {
        console.log(`Found cart count from drawer: ${count}`);
        return count;
      }
    }
    
    // Method 2: Parse from drawer title "Your cart (10)"
    const drawerTitle = document.querySelector('.cart-drawer h2, .cart-drawer .drawer-title, .drawer h2, [data-cart-drawer] h2');
    if (drawerTitle && drawerTitle.textContent) {
      const match = drawerTitle.textContent.match(/\((\d+)\)/);
      if (match) {
        const count = parseInt(match[1]);
        console.log(`Found cart count from drawer title: ${count}`);
        return count;
      }
    }
    
    // Method 3: Sum quantities from drawer line items
    const drawerItems = document.querySelectorAll('.cart-drawer .line-item, .cart-drawer .cart-item, .drawer .line-item, [data-cart-drawer] .line-item');
    let total = 0;
    drawerItems.forEach(item => {
      const qtyInput = item.querySelector('input[name*="quantity"], input[data-quantity], .quantity-input');
      if (qtyInput) {
        const qty = parseInt(qtyInput.value) || 0;
        total += qty;
        console.log(`Adding drawer item quantity: ${qty}, total now: ${total}`);
      }
    });
    if (total > 0) {
      console.log(`Calculated total from drawer items: ${total}`);
      return total;
    }
    
    // Method 4: Try global cart count (header cart icon)
    const globalCartCount = document.querySelector('.cart-link .cart-count, .header-cart .cart-count, [data-cart-count]');
    if (globalCartCount) {
      const count = parseInt(globalCartCount.textContent || globalCartCount.getAttribute('data-count') || '0');
      if (count > 0) {
        console.log(`Found cart count from header: ${count}`);
        return count;
      }
    }
    
    // Method 5: Fetch from Shopify Ajax API (most reliable for drawers)
    return new Promise((resolve) => {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          resolve(cart.item_count);
        })
        .catch(() => {
          resolve(0);
        });
    });
  }
  
  function updateCartStatusWithQuantity(cartTotal) {
    // Cart drawer specific checkout button selectors
    const checkoutButtons = document.querySelectorAll(`
      .cart-drawer .checkout-button,
      .cart-drawer [href*="checkout"],
      .drawer .checkout-button,
      .drawer [href*="checkout"],
      [data-cart-drawer] .checkout-button,
      [data-cart-drawer] [href*="checkout"],
      .cart-drawer-checkout,
      .drawer-checkout,
      .btn--checkout,
      .cart__checkout-button,
      .checkout-btn
    `);
    
    const statusElement = document.getElementById('cart-quantity-status');
    const currentTotalSpan = document.getElementById('current-cart-total');
    
    
    // Update the display
    if (currentTotalSpan) {
      currentTotalSpan.textContent = cartTotal;
    }
    
    if (cartTotal < MINIMUM_QUANTITY) {
      
      
      // Disable checkout buttons with drawer-specific styling
      checkoutButtons.forEach(button => {
        button.disabled = true;
        button.style.opacity = '0.4';
        button.style.cursor = 'not-allowed';
        button.style.filter = 'grayscale(100%)';
        button.title = `Minimum order is ${MINIMUM_QUANTITY} items`;
        button.setAttribute('data-minimum-blocked', 'true');
        
        // IMPORTANT: Don't modify href for drawer functionality
        // Just prevent the checkout action
      });
      
      // Update status message
      if (statusElement) {
        statusElement.innerHTML = `
          Current quantity: <span id="current-cart-total">${cartTotal}</span> items
          <span style="color: #d63031; font-weight: bold;">- Add ${MINIMUM_QUANTITY - cartTotal} more items to checkout</span>
        `;
      }
      
      // Add checkout click interceptor
      document.addEventListener('click', checkoutClickHandler, true);
      
    } else {
      console.log('Allowing checkout - minimum met');
      
      // Enable checkout buttons
      checkoutButtons.forEach(button => {
        button.disabled = false;
        button.style.opacity = '1';
        button.style.cursor = 'pointer';
        button.style.filter = 'none';
        button.title = '';
        button.removeAttribute('data-minimum-blocked');
      });
      
      if (statusElement) {
        statusElement.innerHTML = `
          Current quantity: <span id="current-cart-total">${cartTotal}</span> items
          <span style="color: #00b894; font-weight: bold;">✓ Minimum met - Ready to checkout</span>
        `;
      }
      
      document.removeEventListener('click', checkoutClickHandler, true);
    }
  }
  
  // Refined click handler that only blocks actual checkout attempts
  function checkoutClickHandler(e) {
    const target = e.target;
    
    // Only block if it's specifically a checkout link/button
    const isCheckoutElement = target.matches(`
      [href*="/checkout"],
      [href*="/checkouts"],
      .checkout-button,
      .btn--checkout,
      .checkout-btn,
      [data-checkout]
    `) || target.closest(`
      [href*="/checkout"],
      [href*="/checkouts"],
      .checkout-button,
      .btn--checkout,
      .checkout-btn,
      [data-checkout]
    `);
    
    // Don't block cart page links or drawer toggles
    const isCartPageLink = target.matches(`
      [href*="/cart"],
      [href="/cart"],
      .cart-link:not([href*="checkout"])
    `) || target.closest(`
      [href*="/cart"]:not([href*="checkout"]),
      .cart-link:not([href*="checkout"])
    `);
    
    if (isCheckoutElement && !isCartPageLink) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      // Get current quantity and show modal
      const cartQuantity = getCartQuantity();
      if (cartQuantity instanceof Promise) {
        cartQuantity.then(qty => {
          if (qty < MINIMUM_QUANTITY) {
            showModal(qty);
          }
        });
      } else if (cartQuantity < MINIMUM_QUANTITY) {
        showModal(cartQuantity);
      }
      
      return false;
    }
  }
  
  async function updateCartStatus() {
    const cartTotal = await getCartQuantity();
    updateCartStatusWithQuantity(cartTotal);
  }
  
  // Initial status update
  updateCartStatus();
  
  // Listen for drawer-specific events
  document.addEventListener('cart:updated', updateCartStatus);
  document.addEventListener('cart:refreshed', updateCartStatus);
  document.addEventListener('drawer:updated', updateCartStatus);
  document.addEventListener('cart:change', updateCartStatus);
  
  // Listen for AJAX cart updates (common in drawers)
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const promise = originalFetch.apply(this, args);
    
    // If it's a cart-related AJAX call, update status after
    if (args[0] && (args[0].includes('/cart') || args[0].includes('cart.js'))) {
      promise.then(() => {
        setTimeout(updateCartStatus, 200);
      });
    }
    
    return promise;
  };
  
  // Listen for quantity changes in drawer
  document.addEventListener('input', function(e) {
    if (e.target.closest('.cart-drawer, .drawer, [data-cart-drawer]') && 
        e.target.matches('input[name*="quantity"], input[data-quantity], .quantity-input')) {
      setTimeout(updateCartStatus, 100);
    }
  });
  
  document.addEventListener('change', function(e) {
    if (e.target.closest('.cart-drawer, .drawer, [data-cart-drawer]') && 
        e.target.matches('input[name*="quantity"], input[data-quantity], .quantity-input')) {
      setTimeout(updateCartStatus, 100);
    }
  });
  
    // Listen for +/- buttons in drawer
  document.addEventListener('click', function(e) {
    if (e.target.closest('.cart-drawer, .drawer, [data-cart-drawer]') && 
        e.target.matches('.quantity-selector button, .qty-btn, [data-quantity-selector] button, .quantity-button, .quantity-change')) {
      setTimeout(updateCartStatus, 200);
    }
  });
  
  // Watch for drawer opening/closing
  const drawerObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && 
          (mutation.attributeName === 'class' || mutation.attributeName === 'style')) {
        const target = mutation.target;
        if (target.matches('.cart-drawer, .drawer, [data-cart-drawer]')) {
          // Drawer visibility changed, update status
          setTimeout(updateCartStatus, 100);
        }
      }
    });
  });
  
  const drawer = document.querySelector('.cart-drawer, .drawer, [data-cart-drawer]');
  if (drawer) {
    drawerObserver.observe(drawer, { attributes: true });
  }
  
  // Periodic update when drawer is visible
  setInterval(() => {
    const drawer = document.querySelector('.cart-drawer, .drawer, [data-cart-drawer]');
    if (drawer && (drawer.classList.contains('open') || drawer.classList.contains('active') || drawer.style.display !== 'none')) {
      updateCartStatus();
    }
  }, 1000);
});